import { baseURL } from '../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { loadingAction } from '../redux/actions/loadingAction';
import { showMessageAction } from '../redux/actions/showMessageAction';
import store from '../redux/store';

export const handleDeleteRequest =
    (url, isShowLoad = false, isShowToast = true, nextPageToLoad = '', responseCode = '') =>
    async (dispatch) => {
        try {
            if (isShowLoad) dispatch(loadingAction(true));
            const response = await axios({
                method: 'delete',
                url: `${baseURL + url}`,
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`
                }
            });

            if (response?.data?.message === 'Invalid Token' || response?.data?.message === 'Session Expired') {
                localStorage.clear();
                setTimeout(() => {
                    window.location.href = '/';
                }, 1000);
            }

            if (isShowToast) {
                if (response?.data?.message === 'Record Not Found') {
                    toast.warn(response?.data?.message || 'Record not found', { autoClose: 2000 });
                } else {
                    if (responseCode === '' || responseCode === response?.data?.responseCode) {
                        toast.success(response?.data?.message || 'Deleted successfully', { autoClose: 2000 });
                    } else {
                        toast.warn(response?.data?.message || 'Something went wrong', { autoClose: 2000 });
                    }
                }
            } else {
                if (response?.data?.message === 'Record Not Found') {
                    store.dispatch(
                        showMessageAction({
                            isShowModal: true,
                            message: response?.data?.message || 'Record not found',
                            isError: true
                        })
                    );
                } else {
                    if (responseCode === '' || responseCode === response?.data?.responseCode) {
                        store.dispatch(
                            showMessageAction({
                                isShowModal: true,
                                message: response?.data?.message || 'Deleted successfully',
                                isError: false,
                                url: nextPageToLoad
                            })
                        );
                    } else {
                        store.dispatch(
                            showMessageAction({
                                isShowModal: true,
                                message: response?.data?.message || 'Something went wrong',
                                isError: true
                            })
                        );
                    }
                }
            }

            if (isShowLoad) dispatch(loadingAction(false));
            return response?.data;
        } catch (error) {
            if (error?.response?.data?.message === 'Invalid Token' || error?.response?.data?.message === 'Session Expired') {
                localStorage.clear();
                setTimeout(() => {
                    window.location.href = '/';
                }, 1000);
            }

            if (isShowLoad) dispatch(loadingAction(false));

            if (!isShowToast) {
                store.dispatch(
                    showMessageAction({
                        isShowModal: true,
                        message: error?.response?.data?.message || 'Something went wrong',
                        isError: true
                    })
                );
            } else if (error?.response?.status === 500 && isShowToast) {
                toast.warn(error?.response?.data?.message || 'Something went wrong', { autoClose: 2000 });
            } else if (error?.response?.status === 400 && isShowToast) {
                toast.warn(error?.response?.data?.message || 'Something went wrong', { autoClose: 2000 });
            } else if (error?.response?.status === 401 && isShowToast) {
                sessionStorage.removeItem('token');
            } else {
                toast.warn(error?.response?.data?.message || 'Something went wrong', { autoClose: 2000 });
            }

            return error?.response;
        }
    };
